import { isEmpty } from "lodash"
import { at } from "lodash-es"
import moment from "moment"
import React, { useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import { ChevronDown, ChevronUp, FileEarmarkText, XCircleFill } from "react-bootstrap-icons"
import BootstrapTable, { ColumnDescription } from "react-bootstrap-table-next"
import filterFactory, { textFilter } from "react-bootstrap-table2-filter"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"
// import BootstrapTable from "react-bootstrap-table-next";
import { useTranslation } from "react-i18next"
import swal from "sweetalert"
import { PurchaseRequestModel } from "../../api/purchaseRequest.api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { SearchBar, SelectFilterColums } from "../../components/Tables/Columns"
import CustomTotal from "../../components/Tables/CustomTotal"
import pageListRenderer from "../../components/Tables/PageListRenderer"
import sizePerPageOptionRenderer from "../../components/Tables/SizePerPageOptionRenderer"
import { GLOBAL_CONSTANTS } from "../../constants/constants"
import { RootState } from "../../store"
import {
    changeInvoice,
    changeStatusCollected,
    loadAllRejectReasons,
    loadPurchaseRequest,
    updateShipmentNumber
} from "../../store/purchaseRequest.store"

let purchaseIdFilter: any, userFilter: any, statusFilter: any

function PurchaseRequestTable({
    purchaseRequest,
    onRejectRequestClick,
    onPurchaseRequestClick,
    onWalletRequestClick
}: {
    purchaseRequest: PurchaseRequestModel[]
    onRejectRequestClick: any
    onPurchaseRequestClick: any
    onWalletRequestClick: any
}) {
    const { t } = useTranslation()
    const [totalPrice, setTotalPrice] = useState(0)
    const [showInvoice, setshowInvoice] = useState(true)
    const [purchaseStatus, setPurchaseStatus] = useState(false)
    const [collectedRemarks, setCollectedRemarks] = useState("")
    const [trackingNumber, setTrackingNumber] = useState("")
    const [updateTrackingNumber, setUpdateTrackingNumber] = useState("")
    const [attachedPictureName, setAttachedPictureName] = useState<any | null>(null)
    const hiddenFileInput = React.useRef<HTMLInputElement>(null)
    const [pictureBase64, setPictureBase64] = useState<any | null>(null)
    const [showError, setshowError] = useState(false)
    const { error: fetchError, loading } = useAppSelector((state: RootState) => state.purchaseRequest)

    const dispatch = useAppDispatch()

    const onRejectRequest = (data: PurchaseRequestModel) => {
        onRejectRequestClick(data)
    }
    const onPurchaseRequest = (data: PurchaseRequestModel) => {
        onPurchaseRequestClick(data, totalPrice)
    }
    const onRequestClick = (data: PurchaseRequestModel) => {
        onWalletRequestClick(data, totalPrice)
    }

    const changeTrackingNumber = (event: any) => {
        setUpdateTrackingNumber(event.target.value)
    }
    const onFilter = (value: string | number | null, id: string) => {
        if (!value) value = ""
        if (id === "request_id") purchaseIdFilter(value)
        else if (id === "User") userFilter(value)
        else if (id === "PurchaseStatusHistories") statusFilter(value)
    }

    const HandleBrowseClick = (event: any) => {
        if (event && hiddenFileInput && hiddenFileInput.current) hiddenFileInput.current.click()
    }
    const handleFile = (event: any) => {
        try {
            let files = event.target.files
            let reader = new FileReader()
            reader.readAsDataURL(files[0])

            reader.onload = (e) => {
                setAttachedPictureName(files[0]?.name)
                setPictureBase64(reader.result)
            }
        } catch (e: any) {}
    }

    const changeInvoiceStatus = (row: any) => {
        var data: any = {
            purchase_request_id: row.id,
            attachment: pictureBase64,
            is_invoice: 1
        }
        dispatch(changeInvoice(data))
        if (!loading) {
            if (fetchError === "" || isEmpty(fetchError)) {
                swal({
                    title: "",
                    text: t("Invoice_Changed"),
                    icon: "success"
                }).then(function () {
                    dispatch(loadPurchaseRequest())
                    dispatch(loadAllRejectReasons())
                })
            } else {
                swal({
                    title: "",
                    text: t("Invoice_Not_Changed"),
                    icon: "error"
                }).then(function () {
                    dispatch(loadPurchaseRequest())
                    dispatch(loadAllRejectReasons())
                })
            }
        }
    }

    const handleClick = (row: any) => {
        if (!collectedRemarks) setshowError(true)
        else setshowError(false)

        var data: any = {
            purchase_request_id: row.id,
            remarks: collectedRemarks
        }
        dispatch(changeStatusCollected(data))
        if (!loading) {
            if (fetchError === "" || isEmpty(fetchError)) {
                swal({
                    title: "",
                    text: t("Change_Status_Collected"),
                    icon: "success"
                }).then(function () {
                    dispatch(loadPurchaseRequest())
                    dispatch(loadAllRejectReasons())
                })
            } else {
                swal({
                    title: "",
                    text: t("No_Change_Status_Collected"),
                    icon: "error"
                }).then(function () {
                    dispatch(loadPurchaseRequest())
                    dispatch(loadAllRejectReasons())
                })
            }
        }
    }

    const saveTrackingNumberClick = async (row: any) => {
        if (!trackingNumber) setshowError(true)
        else setshowError(false)

        var data: any = {
            purchase_request_id: row.id,
            shipment_number: updateTrackingNumber ? updateTrackingNumber : trackingNumber
        }
        let trackingData = await dispatch(updateShipmentNumber(data))
        if (trackingData?.payload?.data && trackingData?.payload?.data?.status) {
            swal({
                title: "",
                text: t(trackingData?.payload?.data?.message),
                icon: "success"
            }).then(function () {
                dispatch(loadPurchaseRequest())
                dispatch(loadAllRejectReasons())
            })
        } else {
            swal({
                title: "",
                text: t("Shipment_not_updated"),
                icon: "error"
            }).then(function () {
                dispatch(loadPurchaseRequest())
                dispatch(loadAllRejectReasons())
            })
        }
    }

    const usersColumns = [
        {
            dataField: "request_id",
            text: t("Purchase_Id"),
            classes: "highlighted-text",
            filter: textFilter({
                getFilter: (filter) => {
                    purchaseIdFilter = filter
                }
            })
        },
        {
            text: t("Date"),
            dataField: "updated_at",
            sort: true,
            formatter: (cell: number) => {
                if (cell) return moment(cell).format("DD MMM yyyy")
            }
        },
        {
            text: t("Customer_Id"),
            dataField: "User.user_pin",
            filter: textFilter({
                getFilter: (filter) => {
                    userFilter = filter
                }
            }),
            formatter: (cell: string | number, row: Record<string, any>) => {
                return cell ? (
                    <div>
                        <span className="d-flex">{cell}</span>
                        <span>{row?.User?.name}</span>
                    </div>
                ) : (
                    ""
                )
            },
            csvFormatter: (cell: string | number, row: Record<string, any>) => {
                return cell ? cell + " ," + row?.User?.name : ""
            }
        },
        {
            text: t("Customer_Pin"),
            dataField: "User.user_pin",
            hidden: true,
            csvExport: false
        },
        {
            text: t("Customer_Name"),
            dataField: "User.name",
            hidden: true,
            csvExport: false
        },
        {
            text: t("Qty"),
            dataField: "quantity",
            formatter: (cell: number) => {
                if (cell) return cell
            }
        },
        {
            text: t("Value"),
            dataField: "amount",
            formatter: (cell: number) => {
                if (cell) return cell + " " + GLOBAL_CONSTANTS.CURRENCY
            }
        },
        {
            dataField: "PurchaseStatusHistories",
            text: t("Status"),
            classes: "w-290-px",
            filter: textFilter({
                getFilter: (filter) => {
                    statusFilter = filter
                }
            }),
            formatter: (cell: Record<string, any>, row: Record<string, any>) => {
                let colorClass = ""
                let status =
                    row?.PurchaseStatusHistories?.find(
                        (purchaseStatus: any) => purchaseStatus.status_id === row?.status_id
                    )?.PurchaseStatus?.name || ""
                if (status === "Purchased") {
                    colorClass = "status-purchased"
                } else if (status === "Rejected") {
                    colorClass = "status-reject"
                } else if (status === "Payment Completed") {
                    colorClass = "status-payment-completed"
                } else if (status === "Collected") {
                    colorClass = "status-collected"
                } else {
                    colorClass = "status-wallet-request"
                }
                return (
                    <div className="request-status">
                        <div className="d-inline">
                            <span className={`status-icon ${colorClass} `}></span>
                            <span className={`status-text ${colorClass} mx-2`}>{status}</span>
                        </div>
                    </div>
                )
            }
        },
        {
            text: t("Transaction details"),
            dataField: "",
            formatter: (cell: any, row: Record<string, any>) => {
                let content = ""
                if (row?.PurchasePaymentTransaction) {
                    if (row?.PurchasePaymentTransaction?.Transaction) {
                        content = `${
                            "ID: " +
                            row?.PurchasePaymentTransaction?.Transaction?.transaction_id +
                            " - Method: " +
                            row?.PurchasePaymentTransaction?.Transaction?.transaction_method
                        }`
                    }
                }
                return (
                    (content === "" ? "" : content + " - ") +
                    (row?.PurchasePaymentTransaction?.WalletTransaction?.id
                        ? "Wallet Involved: Yes"
                        : content === ""
                          ? t("Not paid")
                          : "Wallet Involved: No")
                )
            }
        }
    ]

    const expandRow = {
        renderer: (row: any): JSX.Element => {
            var paymentRecieved = row?.amount
            let walletBalance =
                row?.User?.LastWalletTransaction && row?.User?.LastWalletTransaction.length > 0
                    ? row?.User?.LastWalletTransaction[0].available_balance
                    : 0
            var balance = 0
            let status =
                row?.PurchaseStatusHistories?.find(
                    (purchaseStatus: any) => purchaseStatus.status_id === row?.status_id
                )?.PurchaseStatus?.name || ""
            let statusHistory: any = {}
            setTrackingNumber("")
            if (row?.PurchaseStatusHistories) {
                statusHistory = row?.PurchaseStatusHistories.find(function (v: any) {
                    return v.status_id === row?.status_id
                })
            }

            if (status === "Payment Completed") {
                if (paymentRecieved > totalPrice) balance = paymentRecieved - totalPrice
                else balance = paymentRecieved
            } else {
                if (paymentRecieved > row?.total_amount) balance = paymentRecieved - row?.total_amount
            }
            let colorClass = ""
            if (status === "Purchased") {
                colorClass = "status-purchased"
            } else if (status === "Rejected") {
                colorClass = "status-reject"
            } else if (status === "Payment Completed") {
                colorClass = "status-payment-completed"
            } else if (status === "Collected") {
                colorClass = "status-collected"
            } else {
                colorClass = "status-wallet-request"
            }
            if (
                (status === "Collected" || status === "Purchased") &&
                row?.shipment_number &&
                !updateTrackingNumber
            )
                setTrackingNumber(row?.shipment_number)
            let attachmentNameParts = []
            let statusAttachment = []
            var attachmentName = ""
            let invoiceProof = []
            if (row.PurchaseAttachments && row.PurchaseAttachments.length > 0)
                attachmentNameParts = at(row.PurchaseAttachments[0]?.Attachment, [
                    "domain",
                    "folder_path",
                    "attachment_name"
                ])

            if (statusHistory && statusHistory?.Attachment) {
                statusAttachment = at(statusHistory?.Attachment, ["domain", "folder_path", "attachment_name"])
            }

            if (row?.ProofOfPurchase) {
                attachmentName = row?.ProofOfPurchase.attachment_name
                invoiceProof = at(row?.ProofOfPurchase, ["domain", "folder_path", "attachment_name"])
            }

            let reasonRemarks = t(statusHistory?.Reason?.name)

            return (
                <Row className="expanding-row px-4 py-4" key={row.id}>
                    <Col xs={12} sm={12} md={12} lg={9}>
                        <div className="heading">{t("Request_Information")}</div>
                        <Row className="expand-data w-100">
                            <Col xs={6} sm={6} md={2} lg={2} className="label">
                                {t("Product_Name")}
                            </Col>
                            <Col xs={6} sm={6} md={5} lg={5} className="value">
                                {row?.product_name}
                            </Col>
                            <Col xs={6} sm={6} md={2} lg={2} className="label">
                                {t("Status")}
                            </Col>
                            <Col xs={6} sm={6} md={3} lg={3} className="value request-status">
                                <span className={`status-icon ${colorClass} `}></span>
                                <span className={`status-text ${colorClass} mx-2`}>{status}</span>
                            </Col>
                        </Row>
                        <Row className="expand-data w-100">
                            <Col xs={6} sm={6} md={2} lg={2} className="label">
                                {t("Size")}
                            </Col>
                            <Col xs={6} sm={6} md={5} lg={5} className="value">
                                {row?.size ? row?.size : "-"}
                            </Col>
                            <Col xs={6} sm={6} md={2} lg={2} className="label">
                                {t("Quantity")}
                            </Col>
                            <Col xs={6} sm={6} md={3} lg={3} className="value">
                                {row?.quantity}
                            </Col>
                        </Row>
                        <Row className="expand-data w-100">
                            <Col xs={6} sm={6} md={2} lg={2} className="label">
                                {t("Color")}
                            </Col>
                            <Col xs={6} sm={6} md={5} lg={5} className="value">
                                {row?.color ? row?.color : "-"}
                            </Col>
                            <Col xs={6} sm={6} md={2} lg={2} className="label">
                                {t("Unit_Price")}
                            </Col>
                            <Col xs={6} sm={6} md={3} lg={3} className="value">
                                {GLOBAL_CONSTANTS.CURRENCY_VAL + " " + row?.unit_price}
                            </Col>
                        </Row>
                        <Row className="expand-data w-100">
                            <Col xs={12} sm={12} md={7} lg={7} className="label">
                                <Row>
                                    <Col xs={6} sm={6} md={4} lg={4} className="label product_url">
                                        {t("Product_URL")}
                                    </Col>
                                    <Col xs={6} sm={6} md={8} lg={8} className="value">
                                        <a href={row?.product_url} target={"_blank"}>
                                            {row?.product_url}
                                        </a>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} sm={12} md={5} lg={5} className="label">
                                <Row>
                                    <Col xs={6} sm={6} md={5} lg={5} className="label fee">
                                        {t("Shipping_Fee")}
                                    </Col>
                                    <Col xs={6} sm={6} md={7} lg={7} className="value">
                                        {GLOBAL_CONSTANTS.CURRENCY_VAL + " " + row?.shipping_fee}
                                    </Col>
                                </Row>
                                <Row className="pt-2">
                                    <Col xs={6} sm={6} md={5} lg={5} className="label fee">
                                        {t("Payment_Received")}
                                    </Col>
                                    <Col xs={6} sm={6} md={7} lg={7} className="value">
                                        {GLOBAL_CONSTANTS.CURRENCY_VAL + " " + row?.amount}
                                    </Col>
                                </Row>
                                <Row className="pt-2">
                                    <Col xs={6} sm={6} md={5} lg={5} className="label fee">
                                        {t("Service_Fee")}
                                    </Col>
                                    <Col xs={6} sm={6} md={7} lg={7} className="value">
                                        {GLOBAL_CONSTANTS.CURRENCY_VAL + " " + row?.service_fee}
                                    </Col>
                                </Row>
                                <Row className="pt-2">
                                    <Col xs={6} sm={6} md={5} lg={5} className="label fee">
                                        {t("Total")}
                                    </Col>
                                    <Col xs={6} sm={6} md={7} lg={7} className="value">
                                        <strong>
                                            {GLOBAL_CONSTANTS.CURRENCY_VAL + " " + row?.total_amount}
                                        </strong>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        {row?.comments && (
                            <Row className="expand-data w-100">
                                <Col xs={6} sm={6} md={2} lg={2} className="label">
                                    {t("Comments")}
                                </Col>
                                <Col xs={6} sm={6} md={9} lg={9} className="value light-gray py-1 px-3">
                                    {row?.comments}
                                </Col>
                            </Row>
                        )}
                        {attachmentNameParts.length > 0 && (
                            <Row className="expand-data w-100">
                                <Col xs={6} sm={6} md={2} lg={2} className="label">
                                    {t("User_Attachments")}
                                </Col>
                                <Col xs={6} sm={6} md={9} lg={9} className="value light-gray px-2 w-auto py-2">
                                    <a href={attachmentNameParts?.join("")} target={"_blank"}>
                                        <img src={attachmentNameParts?.join("")} width="100" height="100" />
                                    </a>
                                </Col>
                            </Row>
                        )}

                        {status !== "Payment Completed" && statusAttachment.length > 0 && (
                            <Row className="expand-data w-100">
                                <Col xs={6} sm={6} md={2} lg={2} className="label">
                                    {t("Ops_Attachments")}
                                </Col>
                                <Col xs={6} sm={6} md={9} lg={9} className="value light-gray px-2 w-auto py-2">
                                    <a href={statusAttachment?.join("")} target={"_blank"}>
                                        {statusAttachment[statusAttachment.length - 1].split(".pdf").length <=
                                            1 && (
                                            <img
                                                src={statusAttachment?.join("")}
                                                width="100"
                                                height="100"
                                                className="op_attachment"
                                            />
                                        )}
                                        {statusAttachment[statusAttachment.length - 1].split(".pdf").length >
                                            1 && statusAttachment?.join("")}
                                    </a>
                                </Col>
                            </Row>
                        )}
                        {(status === "Purchased" || status === "Collected") && (
                            <Row className="expand-data w-100">
                                <Col xs={6} sm={6} md={2} lg={2} className="label">
                                    {t("Remarks_Tracking")}
                                </Col>
                                <Col xs={6} sm={6} md={9} lg={9} className="value light-gray px-4 py-2">
                                    <div className=" mt-2">
                                        <input
                                            type="text"
                                            value={updateTrackingNumber ? updateTrackingNumber : trackingNumber}
                                            onChange={(event: any) => changeTrackingNumber(event)}
                                            className="form-control"
                                            placeholder={t("Number")}
                                        />
                                        <Button
                                            onClick={() => saveTrackingNumberClick(row)}
                                            className="my-3 transfer-wallet">
                                            {t("Save")}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        )}
                        {status === "Collected" && statusHistory && statusHistory?.remarks && (
                            <Row className="expand-data w-100">
                                <Col xs={6} sm={6} md={2} lg={2} className="label">
                                    {t("Collection_Remarks")}
                                </Col>
                                <Col xs={6} sm={6} md={9} lg={9} className="value">
                                    {statusHistory?.remarks}
                                </Col>
                            </Row>
                        )}
                        {status === "Purchased" && (
                            <Row className="expand-data w-100">
                                <Col xs={6} sm={6} md={2} lg={2} className="label">
                                    {t("Purchase_Status")}
                                </Col>
                                <Col xs={6} sm={6} md={9} lg={9} className="value light-gray px-4 py-2">
                                    <Form.Group className="mt-2" controlId="status">
                                        <Form.Check
                                            type="checkbox"
                                            name="status"
                                            label={t("Collected")}
                                            className="purchase_status"
                                            checked={purchaseStatus}
                                            onClick={() => setPurchaseStatus(!purchaseStatus)}
                                        />
                                    </Form.Group>
                                    {purchaseStatus && (
                                        <>
                                            <Form.Group
                                                className="my-3"
                                                controlId="exampleForm.ControlTextarea1">
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    placeholder={t("Enter Remarks")}
                                                    onChange={(event: any) =>
                                                        setCollectedRemarks(event.target.value)
                                                    }
                                                />
                                                <div className={showError ? "show error" : "hide error"}>
                                                    {t("Add_Remarks")}
                                                </div>
                                            </Form.Group>

                                            <Button
                                                onClick={() => handleClick(row)}
                                                className="  py-1 transfer-wallet">
                                                {t("Save")}
                                            </Button>
                                        </>
                                    )}
                                </Col>
                            </Row>
                        )}
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={3} className="white-background py-4 px-4">
                        <div className="price-fit-box">
                            <Row>
                                <Col className="heading">{t("Personal_Information")}</Col>
                            </Row>
                            <Row className="form-label my-3">
                                <Col className="label">{t("Payment_recieved")}</Col>
                            </Row>
                            <Row>
                                <Col className="form-label d-flex">
                                    <input
                                        type="text"
                                        value={paymentRecieved}
                                        disabled
                                        className="form-control"
                                    />
                                    <div className="currency-prefix"> {GLOBAL_CONSTANTS.CURRENCY}</div>
                                </Col>
                            </Row>
                            {status !== "Rejected" && (
                                <>
                                    <Row className="form-label my-3">
                                        <Col className="label required">{t("Total_price")}</Col>
                                    </Row>
                                    {status === "Payment Completed" && (
                                        <Row>
                                            <Col className="form-label d-flex">
                                                <input
                                                    type="text"
                                                    value={totalPrice ? totalPrice : ""}
                                                    className="form-control"
                                                    onChange={(e: any) => setTotalPrice(e.target.value)}
                                                />
                                                <div className="currency-prefix">
                                                    {" "}
                                                    {GLOBAL_CONSTANTS.CURRENCY}
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    {status !== "Payment Completed" && (
                                        <Row>
                                            <Col className="form-label d-flex">
                                                <input
                                                    type="text"
                                                    value={row?.amount}
                                                    disabled
                                                    className="form-control"
                                                />
                                                <div className="currency-prefix">
                                                    {" "}
                                                    {GLOBAL_CONSTANTS.CURRENCY}
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </>
                            )}
                            {(status === "Purchased" || status === "Collected") && balance > 0 && (
                                <Row className="balance-row mx-0 my-2 py-2">
                                    <Col className="label wallet-balance">
                                        <span className="sterik mx-2">*</span>
                                        <span className="balance">
                                            {balance} {GLOBAL_CONSTANTS.CURRENCY}{" "}
                                        </span>
                                        {t("transfered_to_wallet")}
                                    </Col>
                                </Row>
                            )}

                            {status === "Rejected" && (
                                <>
                                    <Row className="form-label my-3 mx-0">
                                        <Col className="label required mx-0 px-0 mb-3">{t("Reason")}</Col>
                                        <input
                                            type="text"
                                            disabled
                                            value={reasonRemarks}
                                            className="form-control"
                                        />
                                    </Row>
                                    <Row className="form-label my-3 mx-0">
                                        <Col className="label required mx-0 px-0">{t("Screenshots")}</Col>
                                    </Row>
                                    <Row>
                                        <Col className="mx-3 px-0 mb-3">
                                            <a href={attachmentNameParts?.join("")} target={"_blank"}>
                                                <img
                                                    src={statusAttachment?.join("")}
                                                    width="100"
                                                    height="100"
                                                    className="op_attachment"
                                                />
                                            </a>
                                        </Col>
                                    </Row>
                                </>
                            )}
                            {status === "Confirmation Request" && (
                                <Row className="balance-row mx-0 my-2 py-2">
                                    <Col className="label wallet-balance">
                                        <span className="sterik mx-2">*</span>
                                        <span className="balance">
                                            {walletBalance} {GLOBAL_CONSTANTS.CURRENCY}{" "}
                                        </span>
                                        {t("Balance_on_Wallet")}
                                    </Col>
                                </Row>
                            )}
                            {status === "Payment Completed" && paymentRecieved > totalPrice && (
                                <Row className="balance-row mx-0 my-2 py-2">
                                    <Col className="label wallet-balance">
                                        <span className="sterik mx-2">*</span>
                                        <span className="balance">
                                            {balance} {GLOBAL_CONSTANTS.CURRENCY}{" "}
                                        </span>
                                        {t("Payment_will_transfer_purchase")}
                                    </Col>
                                </Row>
                            )}
                            {status === "Payment Completed" &&
                                paymentRecieved < totalPrice &&
                                walletBalance < totalPrice - paymentRecieved && (
                                    <Row className="balance-row mx-0 my-2 py-2">
                                        <Col className="label wallet-balance">
                                            <span className="sterik mx-2">*</span>
                                            <span className="balance">
                                                {balance} {GLOBAL_CONSTANTS.CURRENCY}{" "}
                                            </span>
                                            {t("Payment_will_transfer")}
                                        </Col>
                                    </Row>
                                )}
                            {status === "Payment Completed" &&
                                paymentRecieved < totalPrice &&
                                walletBalance > totalPrice - paymentRecieved && (
                                    <Row className="balance-row mx-0 my-2 py-2">
                                        <Col className="label wallet-balance">
                                            <span className="sterik mx-2">*</span>
                                            <span className="balance">
                                                {walletBalance} {GLOBAL_CONSTANTS.CURRENCY}{" "}
                                            </span>
                                            {t("wallet_balance_transfer")}
                                        </Col>
                                    </Row>
                                )}
                            {status === "Payment Completed" && (
                                <Row className="purchase-request-button w-100 my-3 mx-0">
                                    <Col className="d-flex mx-0 px-0">
                                        <button
                                            type="button"
                                            className="w-50 reject btn btn-primary py-2"
                                            onClick={() => onRejectRequest(row)}>
                                            {t("Reject")}
                                        </button>
                                        {paymentRecieved >= totalPrice && totalPrice > 0 && (
                                            <button
                                                type="button"
                                                className="w-50 purchase btn btn-primary py-2"
                                                onClick={() => onPurchaseRequest(row)}>
                                                {t("Purchase")}
                                            </button>
                                        )}
                                        {totalPrice > paymentRecieved &&
                                            walletBalance >= totalPrice - paymentRecieved && (
                                                <button
                                                    type="button"
                                                    className="w-50 purchase btn btn-primary py-2"
                                                    onClick={() => onRequestClick(row)}>
                                                    {t("Request")}
                                                </button>
                                            )}
                                        {totalPrice > paymentRecieved &&
                                            walletBalance < totalPrice - paymentRecieved && (
                                                <button
                                                    type="button"
                                                    className="w-50 purchase btn btn-primary py-2"
                                                    disabled>
                                                    {t("Request")}
                                                </button>
                                            )}
                                    </Col>
                                </Row>
                            )}
                            {(status === "Collected" || status === "Purchased") && (
                                <>
                                    <Row className="form-label my-3">
                                        <Col className="label required">{t("Invoice")}</Col>
                                    </Row>
                                    {showInvoice && (
                                        <Row>
                                            <Col className="form-label d-flex w-100">
                                                <div className="d-flex  w-100">
                                                    <FileEarmarkText
                                                        color="#1E88E5"
                                                        size={20}
                                                        className="arrow-icon"
                                                    />
                                                    <a href={invoiceProof?.join("")} target={"_blank"}>
                                                        <span className="attachment-name mx-2">
                                                            {attachmentName}
                                                        </span>
                                                    </a>
                                                </div>
                                                <div>
                                                    <XCircleFill
                                                        color="#E01E5A"
                                                        size={20}
                                                        className="mx-2 arrow-icon"
                                                        onClick={() => setshowInvoice(false)}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    {!showInvoice && (
                                        <>
                                            <Row>
                                                <Col className="form-label d-flex w-100">
                                                    <div className="d-flex mb-2  w-100">
                                                        <div className="browse-field">
                                                            {attachedPictureName}
                                                        </div>
                                                        <input
                                                            type="button"
                                                            value="Browse"
                                                            id="fakeBrowse"
                                                            className="browse-button"
                                                            onClick={HandleBrowseClick}
                                                        />
                                                    </div>
                                                    <input
                                                        id="fileCustomBrowse"
                                                        ref={hiddenFileInput}
                                                        name="file"
                                                        type="file"
                                                        onChange={handleFile}
                                                        className="form-control-file upload-button d-none"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="form-label d-flex w-100">
                                                    {attachedPictureName && (
                                                        <Button
                                                            onClick={() => changeInvoiceStatus(row)}
                                                            className="w-100  py-1 transfer-wallet">
                                                            {t("Confirm_to_Upload")}
                                                        </Button>
                                                    )}
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </Col>
                </Row>
            )
        },
        showExpandColumn: true,
        expandByColumnOnly: true,
        expandHeaderColumnRenderer: ({ isAnyExpands }: { isAnyExpands: boolean }) => {
            return <></>
        },
        expandColumnRenderer: ({ expanded }: { expanded: boolean }) => {
            if (expanded) {
                return <ChevronUp color="#2D3748" size={10} className="mx-2 my-3 arrow-icon" />
            }
            return <ChevronDown color="#2D3748" size={10} className="mx-2 my-3 arrow-icon" />
        }
    }

    const options = {
        sizePerPage: 50,
        hideSizePerPage: false,
        hidePageListOnlyOnePage: true,
        sizePerPageOptionRenderer,
        showTotal: true,
        pageListRenderer,
        paginationTotalRenderer: CustomTotal
    }

    const { ExportCSVButton } = CSVExport

    return (
        <div className="table-responsive">
            {usersColumns && (
                <ToolkitProvider
                    keyField="request_id"
                    data={purchaseRequest}
                    columns={usersColumns as ColumnDescription<any, any>[]}
                    search={{ searchFormatted: true }}
                    exportCSV={{
                        fileName: "PurchaseTable.csv",
                        noAutoBOM: false,
                        exportAll: false,
                        onlyExportFiltered: true
                    }}>
                    {(props) => (
                        <div className="table-container my-4">
                            <Row className="search mx-2 purchase-search">
                                <Col xs={12} sm={12} md={12} lg={10}>
                                    <Row>
                                        <Col
                                            xs={12}
                                            sm={6}
                                            md={6}
                                            lg={3}
                                            className="purchase-select-column pl-0">
                                            <SelectFilterColums
                                                preFilteredRows={props.baseProps.data}
                                                id="request_id"
                                                text={t("Purchase Id")}
                                                {...props.searchProps}
                                                onFilterClick={onFilter}
                                            />
                                        </Col>
                                        <Col xs={12} sm={6} md={6} lg={3}>
                                            <SelectFilterColums
                                                preFilteredRows={props.baseProps.data}
                                                id="User"
                                                subId="user_pin"
                                                text={t("Account_Id")}
                                                {...props.searchProps}
                                                onFilterClick={onFilter}
                                            />
                                        </Col>
                                        {/* <Col xs={12} sm={6} md={6} lg={3}>
												<SelectFilterColums preFilteredRows={props.baseProps.data} id="PurchaseStatusHistories"  subId="PurchaseStatus" otherSubId="name" text={t("Status")} table={"purchase_request"} {...props.searchProps} onFilterClick={onFilter} />
											</Col> */}
                                        <Col xs={12} sm={6} md={6} lg={4}></Col>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={2}>
                                    <SearchBar {...props.searchProps} />
                                </Col>
                                <Col className="d-none">
                                    {/* <ExportCSVButton {...props.csvProps} id="usersExportButton">
                        Export
                    </ExportCSVButton> */}
                                </Col>
                            </Row>
                            <Row className="table-data my-3">
                                <Col>
                                    <BootstrapTable
                                        expandRow={expandRow}
                                        {...props.baseProps}
                                        wrapperClasses="table-wrapper my-3 "
                                        headerClasses="header-class"
                                        bordered={false}
                                        noDataIndication={t("No_Record")}
                                        filter={filterFactory()}
                                        rowClasses="custom-table-row"
                                        condensed={true}
                                        pagination={paginationFactory(options)}
                                        sort={{ dataField: "email_verified_at", order: "desc" }}
                                    />
                                </Col>
                            </Row>
                        </div>
                    )}
                </ToolkitProvider>
            )}
        </div>
    )
}

export default PurchaseRequestTable
